import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFilter = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M5.26054 5H26.7394C27.5311 5 28.2482 5.46693 28.5685 6.19089C28.8887 6.91485 28.7518 7.75958 28.2193 8.34535L20 17.3866V24.4648C20 25.1335 19.6658 25.758 19.1094 26.1289L15.1094 28.7956C14.4957 29.2047 13.7066 29.2429 13.0563 28.8948C12.406 28.5468 12 27.8691 12 27.1315V17.3866L3.78066 8.34535C3.24815 7.75958 3.11125 6.91485 3.43151 6.19089C3.75177 5.46693 4.4689 5 5.26054 5ZM26.738 7H5.26099L13.4799 16.0413C13.7727 16.3634 13.9513 16.7709 13.9914 17.2011L14 17.3866V27.1315L18 24.4648V17.3866C18 16.8891 18.1854 16.4094 18.5201 16.0413L26.738 7Z",
		fill: "currentColor"
	})
});
export default SvgFilter;
